import styled from 'styled-components'

export const ExploreInvestmentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 30px;
  justify-items: center;

  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    align-items: center;
    justify-content: center;
  }
  .investmentCard {
    background: #ffffff;
    border-radius: 10px;
    height: 350px;
    width: 330px;
    padding-bottom: 15px;
    box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.09);
  }
  .investment_card_container.sold {
    opacity: 0.6;
  }
  .profit {
    margin-top: -10px;
  }
  .sold_investment {
    /* cursor: none; */
    pointer-events: none;
  }

  .spinner_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card_header {
    height: 160px;
    width: 330px;
    position: relative;
    .card_img {
      height: 160px;
      width: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 10px 10px 0 0;
      position: absolute;
    }
    .sold {
      background-color: ${({ theme }) => theme.colors.soldOutColor} !important;
    }
    .card_type {
      position: absolute;
      right: 20px;
      top: 10px;
      background: #2336ff;
      border-radius: 4.20921px;
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 6px;
      p {
        font-style: normal;
        font-weight: 600;
        font-size: 9.02682px;
        line-height: 144.8%;
        text-align: center;
        letter-spacing: 0.14em;
        color: #ffffff;
      }
    }
  }

  .card_body {
    padding: 0 10px;

    .title h3 {
      color: ${({ theme }) => theme.colors.black};
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xl};
      line-height: 29px;
      text-transform: capitalize;
    }

    .profit_text {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-size: ${({ theme }) => theme.fontSize.x2};
      color: ${({ theme }) => theme.colors.gray};
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      letter-spacing: 0.75px;
    }

    .profit_text span {
      color: ${({ theme }) => theme.colors.exploreColor};
    }
    .sector {
      color: ${({ theme }) => theme.colors.investTextColor};
      font-family: ${({ theme }) => theme.fontFamily.inter};
    }
    .sector_amount_wrapper {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
    }

    .sector-text {
      font-style: normal;
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x5};
      line-height: 19px;
      letter-spacing: 0.75px;
      color: ${({ theme }) => theme.colors.contestPrimary};
    }
    .sector-title {
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      letter-spacing: 0.75px;
      color: ${({ theme }) => theme.colors.activeBlue};
      text-transform: lowercase;
      margin-top: -10px;
    }
    .sector-amount {
      font-style: normal;
      font-weight: 700;
      font-size: ${({ theme }) => theme.fontSize.x5};
      line-height: 19px;
      letter-spacing: 0.75px;
      color: ${({ theme }) => theme.colors.navyBlue};
      margin-top: -10px;
    }
    .sold-details {
      height: 32px;
      text-align: center;
      width: 120px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
    }
  }
`
